import { zonasHorariasTypes, _FULFILLED, _PENDING, _REJECTED } from '../actions/types';
const initialState = {
    list: [],
    isFetching: false,
}

export default function index(state = initialState, action={}) {

    switch (action.type) {
        case zonasHorariasTypes.MOSTRAR_ZONAS_HORARIAS + _PENDING: {
            return {
                ...state,
                isFetching: true,
            }
        }
        case zonasHorariasTypes.MOSTRAR_ZONAS_HORARIAS + _FULFILLED: {
            return {
                ...state,
                list: action.payload.data,
                isFetching: false,
            }
        }
        case zonasHorariasTypes.MOSTRAR_ZONAS_HORARIAS + _REJECTED: {
            return {
                ...state,
                isFetching: false,
            }
        }
        case zonasHorariasTypes.SET_ZONAS_HORARIAS: {
            return {
                ...state,
                list: action.payload
            }
        }
    default:
      return state;
  }
}
